import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_back",
  "use": "arrow_back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_back\">\r\n<path d=\"M17 18.12L10.2011 12L17 5.88L14.9069 4L6 12L14.9069 20L17 18.12Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol